import { createSelector } from 'reselect'

import { selectState } from './selectState'

export const selectJbpSettingsRoleOptions = createSelector(
  [selectState],
  (state) => state.data.stRoles
)
